module.exports = __webpack_public_path__ + "static/EmeraldCircuitWP-7fd178a18827596a0076ef0300284156.pdf";